module.exports = __webpack_public_path__ + "static/media/accusoft.4380fd25.svg";